import { usersURL, globalUrl, apiUrl } from "../Config/Url";
import axios from "axios";
import { principals } from "../Config/Principals";

const { ht, iskon } = principals;

export const userServices = {
  get,
  getById,
  create,
  update,
  getRoles,
  validateOib,
  deleteUser,
  getUsersByTenant,
  addUserToTenant,
  addUserToStore,
  deleteUserFromStore,
  deleteUserFromTenant,
};

async function get({
  tenantId,
  searchName,
  isDeactivated,
  sortName,
  isAsc,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${usersURL}/search`, {
      tenantId,
      searchText: searchName,
      isDeleted: isDeactivated,
      sortName,
      isAsc,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getById(userId) {
  return axios
    .get(`${usersURL}/${userId}`)
    .then((res) => res)
    .catch((err) => err.response.data);
}

async function create({
  isActive,
  loginName,
  realName,
  printName,
  personalIdentificationNumber,
  phone,
  email,
  pin,
  roleId,
  tenantId,
  posPriceEdit,
  posDiscountEdit,
  posProductEdit,
  posInvoiceCopyEdit,
  posHardReset,
  posCashierEdit,
  posCodeBookEdit,
  posDraftEdit,
  posDuplicateEdit,
  posStornoEdit,
  rfidTag,
  tempUser,
}) {
  return axios
    .post(usersURL, {
      isActive,
      loginName,
      realName,
      printName,
      personalIdentificationNumber,
      phone,
      email,
      pin,
      roleId,
      tenantId,
      posPriceEdit,
      posDiscountEdit,
      posProductEdit,
      posInvoiceCopyEdit,
      posHardReset,
      posCashierEdit,
      posCodeBookEdit,
      posDraftEdit,
      posDuplicateEdit,
      posStornoEdit,
      rfidTag: "",
      principalId: window.REACT_APP_VENDOR === "ht" ? ht : ht,
      tempUser,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function update({
  userId,
  loginName,
  realName,
  printName,
  personalIdentificationNumber,
  phone,
  email,
  pin,
  posPriceEdit,
  posDiscountEdit,
  posProductEdit,
  posInvoiceCopyEdit,
  posHardReset,
  posCashierEdit,
  posCodeBookEdit,
  posDraftEdit,
  posDuplicateEdit,
  posStornoEdit,
  rfidTag,
  roleId,
  tempUser,
}) {
  return axios
    .put(`${usersURL}/${userId}`, {
      loginName,
      realName,
      printName,
      personalIdentificationNumber,
      phone,
      email,
      pin,
      posPriceEdit,
      posDiscountEdit,
      posProductEdit,
      posInvoiceCopyEdit,
      posHardReset,
      posCashierEdit,
      posCodeBookEdit,
      posDraftEdit,
      posDuplicateEdit,
      posStornoEdit,
      rfidTag: "",
      principalId: window.REACT_APP_VENDOR === "ht" ? ht : ht,
      roleId,
      tempUser,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getRoles(roleId) {
  return axios
    .get(`${globalUrl}/roles?roleId=${roleId}`)
    .then((res) => res)
    .catch((err) => console.log(err.response));
}

async function deleteUser(userId) {
  return axios
    .delete(`${usersURL}/${userId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteUserFromStore(userId, storeId) {
  return axios
    .delete(`${usersURL}/${userId}/remove/${storeId}/store`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteUserFromTenant(userId, tenantId) {
  return axios
    .delete(`${usersURL}/${userId}/remove/${tenantId}/tenant`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getUsersByTenant(url) {
  return axios
    .get(`${apiUrl}/${url}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function addUserToTenant(userId, tenantId) {
  return axios
    .put(`${usersURL}/${userId}/add/${tenantId}/tenant`)
    .then((res) => res)
    .catch((err) => console.log(err.response));
}

async function addUserToStore(userId, storeId) {
  return axios
    .put(`${usersURL}/${userId}/add/${storeId}/store`)
    .then((res) => res)
    .catch((err) => console.log(err.response));
}

function validateOib(oib) {
  if (oib.length != 11) return false;
  var b = parseInt(oib, 10);
  if (isNaN(b)) return false;
  var a = 10;
  for (var i = 0; i < 10; i++) {
    a = a + parseInt(oib.substr(i, 1), 10);
    a = a % 10;
    if (a == 0) a = 10;
    a *= 2;
    a = a % 11;
  }
  var kontrolni = 11 - a;
  if (kontrolni == 10) kontrolni = 0;

  return kontrolni == oib[10] ? true : false;
}
